export default ['ailoop.io', 'weloop.org', 'meiser.fr', 'frankwerner.ch'];
